import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Globe, Camera, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const fadeIn = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.6
  }
};
export function Sellers() {
  return <div className="w-full bg-sand min-h-screen pt-24" data-id="element-602" data-mp="3lgq0dt23ljzv">
      {/* Hero */}
      <section className="py-20 px-4 text-center max-w-4xl mx-auto" data-id="element-603" data-mp="3len1ejiywgj0">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-4xl md:text-6xl font-serif text-navy mb-6" data-id="element-604" data-mp="3ggva9rq5cyfv">
          Elevate Your Listing
        </motion.h1>
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="text-lg md:text-xl font-light text-navy/70 leading-relaxed" data-id="element-605" data-mp="82mr1a9ilk0d">
          We don't just list properties; we market lifestyles. Our approach
          ensures your Cabo home reaches the right buyers across the globe with
          unmatched presentation.
        </motion.p>
      </section>

      {/* Value Prop */}
      <section className="py-20 bg-white" data-id="element-606" data-mp="iy1b88pnxnbq">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-607" data-mp="o0a5r9i6oxfy">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-608" data-mp="s12fe3uyx4cr">
            <motion.div {...fadeIn} transition={{
            delay: 0.1
          }} className="p-8 border border-navy/10 hover:border-gold transition-colors" data-id="element-609" data-mp="rz99iqs6io5t">
              <Globe className="text-gold mb-6" size={32} data-id="element-610" data-mp="16pym9xlagbbs" />
              <h3 className="text-xl font-serif text-navy mb-4" data-id="element-611" data-mp="16rjhlpfffyap">
                Global Reach
              </h3>
              <p className="text-navy/70 font-light text-sm leading-relaxed" data-id="element-612" data-mp="1bpb6sboot6b7">
                Targeted marketing campaigns reaching high-net-worth individuals
                in key feeder markets: California, Texas, Utah, and Western
                Canada.
              </p>
            </motion.div>
            <motion.div {...fadeIn} transition={{
            delay: 0.2
          }} className="p-8 border border-navy/10 hover:border-gold transition-colors" data-id="element-613" data-mp="vs1uipbu8bin">
              <Camera className="text-gold mb-6" size={32} data-id="element-614" data-mp="zsc92qdp4a94" />
              <h3 className="text-xl font-serif text-navy mb-4" data-id="element-615" data-mp="zrsp744hjbsg">
                Editorial Presentation
              </h3>
              <p className="text-navy/70 font-light text-sm leading-relaxed" data-id="element-616" data-mp="1en8q9t3hg7yc">
                Magazine-quality photography, cinematic video tours, and
                compelling copywriting that tells the unique story of your
                property.
              </p>
            </motion.div>
            <motion.div {...fadeIn} transition={{
            delay: 0.3
          }} className="p-8 border border-navy/10 hover:border-gold transition-colors" data-id="element-617" data-mp="3bjy4ccmz59cn">
              <TrendingUp className="text-gold mb-6" size={32} data-id="element-618" data-mp="1haaqzls7kh1r" />
              <h3 className="text-xl font-serif text-navy mb-4" data-id="element-619" data-mp="1h9rbscty06rf">
                Data-Driven Pricing
              </h3>
              <p className="text-navy/70 font-light text-sm leading-relaxed" data-id="element-620" data-mp="1m6rimpym9djl">
                In-depth market analysis to position your property perfectly,
                maximizing your return while minimizing time on market.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-navy text-sand text-center" data-id="element-621" data-mp="139gheztfca1i">
        <div className="max-w-3xl mx-auto px-4" data-id="element-622" data-mp="13c2wrlmk3tua">
          <motion.div {...fadeIn} data-id="element-623" data-mp="2sq7q22trghcp">
            <h2 className="text-3xl md:text-4xl font-serif text-white mb-6" data-id="element-624" data-mp="2sn3egkdyujc0">
              Ready to discover your property's true value?
            </h2>
            <p className="text-sand/70 font-light text-lg mb-10" data-id="element-625" data-mp="xkyo2vn8jrni">
              Connect with us for a confidential, no-obligation market analysis
              of your Cabo property.
            </p>
            <Link to="/contact" className="inline-flex items-center bg-gold text-white px-8 py-4 uppercase tracking-wider text-sm font-medium hover:bg-gold-dark transition-colors" data-id="element-626" data-mp="oka99yq0pn9k">
              Request Market Analysis
              <ArrowRight className="ml-2" size={18} data-id="element-627" data-mp="9wffsg46revf" />
            </Link>
          </motion.div>
        </div>
      </section>
    </div>;
}